import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";
import { PlaceAdministratorCategory } from "@/constants/place";

import { PlaceAdministratorTableColumns } from "./-table/type";

export const PlaceAdministratorTableFilterSchema = z.object({
  sortOrder: z
    .nativeEnum(OrderDirection)
    .default(OrderDirection.ASC)
    .optional(),
  sortColumn: z.enum([PlaceAdministratorTableColumns.ROLE]).optional(),
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),

  category: z
    .nativeEnum(PlaceAdministratorCategory)
    .optional()
    .default(PlaceAdministratorCategory.ALL),
  freeText: z.string().optional(),
  placeRoleIdIn: z.array(z.string()).optional(),
});
